import {
  GET_CLIENT_INFORMATION,
  GET_AUTH_INFORMATION,
  GET_LOADER_VISIBILITY,
  GET_ENGAGEMENT_COUNT,
  GET_NOTIFICATION_SUMMARY,
  GET_RISK_PROFILE_DATA,
  GET_CLIENT_Session,
} from "../../../helpers/vuex-constants";

export default {
  [GET_CLIENT_INFORMATION](state) {
    return state.clientInformation;
  },
  [GET_CLIENT_Session](state) {
    return state.sessionId;
  },
  [GET_NOTIFICATION_SUMMARY](state) {
    return state.notificationSummary;
  },
  [GET_AUTH_INFORMATION](state) {
    return state.authInformation;
  },
  [GET_LOADER_VISIBILITY](state) {
    return state.isShowLoader;
  },
  [GET_ENGAGEMENT_COUNT](state) {
    return state.engagementData;
  },
  [GET_RISK_PROFILE_DATA](state) {
    return state.riskprofiledata;
  },
};
